module.exports = __webpack_public_path__ + "static/media/ergoverment.4e2bd731.svg";